import "./Navbar.css";
import soundOn from "../../assets/img/sound-on.png";
import soundOff from "../../assets/img/sound-off.png";
import rating from "../../assets/img/rating.webp";

import { SUPPORTED_LANGUAGES, NUMBER_QUESTIONS_END } from "../../utils/config";
import { useEffect, useState } from "react";

export function Navbar({ isSound, setIsSound, lang, setLang, count, setRating }) {
	const [flag, setFlag] = useState(null);

	useEffect(() => {
		const flagImg = require("../../assets/img/lang/" + String(lang) + ".webp");
		setFlag(flagImg);
	}, [lang]);

	function switchLanguage() {
		const currentIndex = SUPPORTED_LANGUAGES.indexOf(lang);
		const nextIndex = (currentIndex + 1) % SUPPORTED_LANGUAGES.length;
		setLang(SUPPORTED_LANGUAGES[nextIndex]);
	}

	return (
		<div className="Navbar">
			<div className="Navbar-start">
				{SUPPORTED_LANGUAGES.length > 1 && (
					<img
						src={flag}
						className="Navbar-img flag"
						onClick={switchLanguage}
						alt={`${lang} language flag`}
					/>
				)}
				<img src={rating} className="Navbar-img" onClick={() => setRating(true)} alt="Rating" />
			</div>
			<div className="Navbar-center">
				<div>
					{count}/{NUMBER_QUESTIONS_END}
				</div>
			</div>
			<div className="Navbar-end">
				<img
					src={isSound ? soundOn : soundOff}
					className="Navbar-img"
					onClick={() => setIsSound(!isSound)}
					alt={isSound ? "Sound on" : "Sound off"}
				/>
			</div>
		</div>
	);
}
